import Component from '../vendor/Component'
import axios from 'axios'

export default class ShopTheLook extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._popupElem = document.querySelector('[data-shop-the-look-popup]')
    this._popupContentElem = this._popupElem.querySelector('[data-shop-the-look-popup-content]')
    this._popupImageElem = this._popupElem.querySelector('[data-shop-the-look-popup-image]')
    this._closeElems = this._popupElem.querySelectorAll('[data-shop-the-look-popup-close]')
    this._popupInnerElem = this._popupElem.querySelector('[data-shop-the-look-popup-inner]')
    this._popupScrollElem = this._popupElem.querySelector('[data-shop-the-look-popup-scroll]')
  }

  async mount() {
    if (this._elem) {
      this._elem.addEventListener('mouseover', async e => {
      })
      this._elem.addEventListener('click', async e => {
        e.preventDefault()
        this._elem.classList.add('loading')

        await this._openPopup()
        await this._preloadPopup(this._options.product_handles, this._options.image)
        await this._triggerPopup()

        document.dispatchEvent(new Event("quickBuy", { bubbles: true }))
        this._elem.classList.remove('loading')
      })
    }

    for (let elem of this._closeElems) {
      elem.addEventListener('click', e => {
        e.preventDefault()
        this._closePopup()
      })
    }

    this._popupElem.addEventListener('click', e => {
      if (e.target === this._popupElem) {
        this._closePopup()
      }
    })

    this._ctx.on('cart-item-added', async () => {
      this._closePopup()
    })
  }

  async _preloadPopup(handles, image) {
    this._popupContentElem.innerHTML = ''
    this._popupImageElem.innerHTML = ''

    let productsInnerHTML = ''

    for (let handle of handles) {
      let { data } = await axios.get(`/products/${handle}?view=shop-the-look-quick-buy`)
      let parser = new DOMParser()
      let html = parser.parseFromString(data, 'text/html')
      let fetchedElem = html.querySelector('.product-page')

      productsInnerHTML = productsInnerHTML + fetchedElem.outerHTML
    }

    this._popupContentElem.innerHTML = productsInnerHTML
    this._popupImageElem.innerHTML = `<img src="${image}">`

    this._theme.mountComponents(this._popupContentElem)
    this._theme.mountComponents(this._popupImageElem)
    this._ctx.emit('ffc--lazy-load-update')
  }

  async _openPopup() {
    this._popupElem.classList.add('shown')
    this._popupInnerElem.classList.add('loading')
  }

  async _triggerPopup() {
    this._ctx.emit('ffc--scroll-lock-elem', null, this._popupScrollElem)
    this._popupInnerElem.classList.remove('loading')
  }

  _closePopup() {
    this._popupElem.classList.remove('shown')
    this._ctx.emit('ffc--clear-all-scroll-locks')
  }
}